import React from 'react';
import Box from "@mui/material/Box/Box";

export function InvalidRoutePage() {
  return (
    <>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingBottom: '0', color: 'red'}}>
        <h1>Invalid URL</h1>
      </Box>
    </>
  );
}